module.exports = __webpack_public_path__ + "static/media/netlify.bf3efff2.png";